/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Admin_TitleInputs */

const es_walkthrough_admin_title = /** @type {(inputs: Walkthrough_Admin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel de Administrador`)
};

const en_walkthrough_admin_title = /** @type {(inputs: Walkthrough_Admin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin Panel`)
};

/**
* | output |
* | --- |
* | "Admin Panel" |
*
* @param {Walkthrough_Admin_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_admin_title = /** @type {((inputs?: Walkthrough_Admin_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Admin_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_admin_title(inputs)
	return en_walkthrough_admin_title(inputs)
});
export { walkthrough_admin_title as "walkthrough.admin_title" }